__turbopack_context__.v({
  "supportingText": "ZpHy7W_supportingText",
  "supportingTextSizeS": "ZpHy7W_supportingTextSizeS",
  "text": "ZpHy7W_text",
  "textSizeS": "ZpHy7W_textSizeS",
  "textsWrapper": "ZpHy7W_textsWrapper",
});
